<template>
    <div class="col-md-12 mx-auto">
        <page-title :title="$t('presenceForm.title')" :showTitle="false"></page-title>
        <div v-if="isLoading" class="loader"></div>
        <div class="card mt-12" v-else>
            <div class="card-header bg-primary text-white">
                <div class="card-title h5 m-0">{{ $t('presenceForm.title') }}</div>
            </div>

            <div class="row p-3">
                <div class="col-lg-2 p-3">
                    <label>{{ $t('presenceForm.period') }}</label>
                    <month-picker @selected="handleSelect"
                                  v-model="selectedMonth"
                                  :clearOption="false"
                                  :alignment="'center'">
                    </month-picker>
                </div>
                <div class="col-lg-2 p-3">
                    <label>{{ $t('administrativePosition.directorate') }}</label>
                    <nomenclature-dropdown :load-by-parent-sort="true"
                                           :parent-sort="nomenclature.Directorate"
                                           :fieldName="$t('registers.employees.gridHeaders.directorate')"
                                           v-model="directorateId"></nomenclature-dropdown>
                </div>
                <div class="col-lg-3 p-3" v-if="hasEditRights">
                    <label>{{ $t('administrativePosition.allEmployeesChange') }}</label>
                    <div class="justify-content-center">
                        <button type="button" class="btn btn-secondary" style="width: 70%"
                                @click="absenseForAllEmployees">{{ $t('add') }}
                        </button>
                    </div>
                </div>
                <div class="col-lg-3 p-3" v-if="hasEditRights">
                    <div class="input-group float-right btn-group">
                        <div class="input-group-addon fas fa-search text-primary" style="display:flex"></div>
                        <input class="form-control fa fa-search" name="query" v-model="searchQuery"
                               v-on:keyup.esc.stop="clearFilter"/>
                        <div v-show="searchQuery" class="input-group-addon" style="display:flex">
                            <button type="button" class="btn btn-light text-danger m-0 p-0" @click.stop="clearFilter"><i
                                class="fas fa-times"></i></button>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 p-3" v-if="hasEditRights">
                    <label></label>
                    <div class="justify-content-center">
                        <button type="button" class="btn btn-secondary" style="width: 80%" @click="excelExport">
                            {{ $t('buttons.excelExport.tooltipText') }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="card-body" :class="{loader: employees == null}">
                <div v-if="employees">
                    <kendo-datasource ref="datasource1"
                                      :transport="transportSettings">
                    </kendo-datasource>

                    <kendo-grid ref="grid"
                                id="grid"
                                :data-source="filteredData"
                                :row-template="rowTemplate"
                                :data-bound="dataBound">
                        <kendo-grid-column :title="$t('person.firstName')"
                                           :width="300"></kendo-grid-column>
                        <kendo-grid-column :title="$t('person.position')"
                                           :width="300"></kendo-grid-column>
                        <kendo-grid-column :title="$t('administrativePosition.directorate')"
                                           :width="300"></kendo-grid-column>
                        <kendo-grid-column v-for="day in days"
                                           :title="`${day}.${month}.${year}`"
                                           id="day"
                                           :width="200">
                        </kendo-grid-column>
                    </kendo-grid>
                </div>
            </div>
        </div>
        <edit-presence :show="showForm" @onClose="closeModal"
                       :absenceDate="absenceDate"
                       :model="absence">
        </edit-presence>
    </div>
</template>

<script>
import PageTitle from '../../components/common/PageTitle';
import store from "../../store/store";
import MonthPicker from "../datepicker/MonthPicker";
import NomenclatureDropdown from "../dropdown/NomenclatureDropdown";
import moment from 'moment';
import EditPresence from "./EditPresence";
import { Absence } from "../../models/models";
import { NomenclatureParentBySort } from '../../models/enums';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            nomenclature: NomenclatureParentBySort,
            transportSettings: {
                read: {
                    url: `${store.getters.baseUrl}/api/employee/`,
                    dataType: 'json',
                    type: 'GET',
                    contentType: 'application/json',
                    beforeSend: this.beforeSend
                },
                parameterMap: this.parameterMap
            },
            selectedMonth: moment(),
            days: null,
            employees: null,
            directorateId: '',
            year: '',
            month: '',
            showForm: false,
            absenceDate: new Date(),
            myIdAsEmployee: '',
            currentUserRoles: '',
            clickedEmployeeId: 0,
            period: '',
            absence: new Absence(),
            restDays: [],
            restDay: 'Почивен ден',
            restDayEn: 'RestDay',
            searchQuery: '',
            isLoading: false
        }
    },
    components: {
        PageTitle,
        MonthPicker,
        EditPresence,
        NomenclatureDropdown,
    },
    methods: {
        dataBound(e) {
            $('.monthDate').off('click');
            $('.monthDate').on('click', (e) => {
                console.log(this);
                console.log($(e.target).data('date'));
                console.log($(e.target).closest('tr').data('id'));
                this.dateClicked($(e.target).data('date'));
                this.clickedEmployeeId = $(e.target).closest('tr').data('id');
                let employee = this.employees.find(obj => {
                    return obj.id === this.clickedEmployeeId;
                });
                this.absence = new Absence(employee.absencesPerDay[$(e.target).data('date') - 1]);
                this.absence.employeeId = this.clickedEmployeeId;
                this.showModalForm();
            })
        },
        parameterMap: function (options, operation) {
            if (operation !== 'read' && options.models) {
                return { models: kendo.stringify(options.models) }
            } else {
                this.saveState();
                return kendo.stringify(options);
            }
        },
        handleSelect(value) {
            console.log('Select', value)
            console.log(this.selectedMonth)
        },
        daysInMonth: function (month, year) {
            this.month = month;
            this.year = year;
            this.getRestDays();
            return new Date(year, month, 0).getDate();
        },
        getRestDays: function () {
            let date = new Date(Date.UTC(this.year, this.month - 1, 1));
            this.restDays = [];
            while (date.getMonth() === this.month - 1) {
                if (date.getDay() === 0 || date.getDay() === 6) {
                    this.restDays.push(date.getDate() - 1);
                }
                date.setDate(date.getDate() + 1);
            }
        },
        beforeSend: function (req) {
            if (this.token) {
                req.setRequestHeader('Authorization', 'Bearer ' + this.token);
            }
        },
        saveState: function () {
            let grid = this.$refs.grid.kendoWidget();

            localStorage["audit-grid-options"] = kendo.stringify(grid.getOptions());
        },
        updateEmployeesDays: function () {
            this.employees.forEach(emp => {
                emp.daysPerMonth = this.days;
                emp.culture = this.$store.getters.currentCulture;
            });
        },
        getCurrentUserEmployeeId() {
            this.$http.get('api/employee/GetEmployeeId')
                .then(
                    result => {
                        this.myIdAsEmployee = result.data;
                    }
                ).catch(err => console.log(err))
        },
        showModalForm() {
            if (this.hasEditRights) {
                this.showForm = true;
            } else if (this.myIdAsEmployee === this.clickedEmployeeId) {
                this.showForm = true;
            }
        },
        absenseForAllEmployees() {
            this.absence = new Absence();
            this.absence.allEmployees = true;
            this.absence.employeeId = 0;
            this.dateClicked(1);
            this.showModalForm();
        },
        getAbsence() {
            this.employees = null;
            this.period = new Date(this.year, this.month - 1, 1).toISOString();
            this.$http.get(`api/presenceForm/GetEmployeeAbsences/${this.period}/${this.directorateId}`).then(result => {
                this.employees = result.data;
                this.updateEmployeesDays();
            }).catch(err => console.log(err));
        },
        dateClicked(date) {
            this.absenceDate = new Date(this.year, this.month - 1, date, 12);
        },
        closeModal() {
            this.showForm = false;
            this.getAbsence();
        },
        excelExport() {
            this.isLoading = true;
            let chosenDate = new Date(this.year, this.month - 1, 1).toISOString();
            let onlyAbsent = false;

            this.$http.get(`api/presenceForm/excelExport/${chosenDate}/${onlyAbsent}/${this.directorateId}`, { responseType: 'blob' })
                .then(response => {
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'EmployeesPresenceForm.xlsx'); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.isLoading = false;
                }).catch(error => {
                this.isLoading = true;
                this.$vs.notify({
                    title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                    text: this.$helpers.errorText(error),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration
                });
            });
        },
        clearFilter() {
            this.searchQuery = '';
        }
    },
    watch: {
        selectedMonth(newVal) {
            let date = (newVal._i.toString()).split('/');
            this.days = this.daysInMonth(date[1], date[0]);
            this.getAbsence();
        },
        directorateId(newVal) {
            this.getAbsence();
        }
    },
    mounted() {
        this.showForm = false;
        this.currentUserRoles = (JSON.parse(localStorage.user)).roles;
        this.days = this.daysInMonth(new Date().getMonth() + 1, new Date().getFullYear());
        this.getCurrentUserEmployeeId();
        this.getAbsence();
    },
    computed: {
        ...mapGetters(['isEnVersion']),
        token: function () {
            return store.getters.authToken;
        },
        rowTemplate: function () {
            var template = '';
            if (this.employees.length > 0) {
                template =
                    '<tr data-uid="#: uid #" data-id="#: id #">' +
                    '<td class="name">' +
                    '#: name #' +
                    '</td>' +
                    '<td class="position">' +
                    '#: position #' +
                    '</td>' +
                    '<td class="directorate">' +
                    '#: directorate #' +
                    '</td>';
                for (let i = 0; i < this.employees[0].daysPerMonth; i++) {
                    if (this.restDays.includes(i)) {
                        template += '<td  class="monthDate text-warning" data-date="' + (i + 1) + '">' +
                            '<span class="monthDate" data-date="' + (i + 1) + '">'
                            + '#: absencesPerDay[' + i + '].absenceType? absencesPerDay[' + i + '].absenceType : "Почивен ден" #' +
                            '<hr class="monthDate" data-date="' + (i + 1) + '">' +
                            '#:  absencesPerDay[' + i + '].substitutionEmployeeId? "Зам: " : ""  #' +
                            '#:  absencesPerDay[' + i + '].substitutionEmployeeId? absencesPerDay[' + i + '].substitutionEmployee : ""  #' +
                            '</span>' +
                            '</td>'
                    } else {
                        template += '<td  class="monthDate" data-date="' + (i + 1) + '">' +
                            '<span class="monthDate" data-date="' + (i + 1) + '">'
                            + '#: absencesPerDay[' + i + '].absenceType? absencesPerDay[' + i + '].absenceType : ""  #' +
                            '<hr class="monthDate" data-date="' + (i + 1) + '">' +
                            '#:  absencesPerDay[' + i + '].substitutionEmployeeId? "Зам: " : ""  #' +
                            '#:  absencesPerDay[' + i + '].substitutionEmployeeId? absencesPerDay[' + i + '].substitutionEmployee : ""  #' +
                            '</span>' +
                            '</td>'
                    }
                }
                template += '</tr>'
            }
            return kendo.template(template);
        },
        hasEditRights() {
            return this.$store.getters.claims.presence.create ||
                this.$store.getters.claims.presence.update;
        },
        filteredData() {
            var filterKey = this.searchQuery && this.searchQuery.toLowerCase();
            var data = this.employees;
            if (filterKey) {
                data = data.filter(function (row) {
                    return Object.keys(row).some(function (key) {
                        return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
                    });
                });
            }

            return data;
        }
    }
}
</script>

<style scoped>
</style>
